export default "__VITE_ASSET__213931f5__"